import { User } from 'app/user';
import { SessionSurvey } from './session-survey.model';

export class SessionParticipantInfo {
  constructor(
    public isFeedbackFinished: boolean = false,
    public isSelfEvaluationFinished: boolean = false,
    public user: User,
    public feedbackStatus?: string,
    public selfEvaluationStatus?: string
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session-participant-info.model.ts